<template>
  <div class="second-module">
    <ul
      v-if="!loading && excelHeader && Object.keys(excelHeader).length"
    >
      <li class="header clearfix">
        <div class="excel-title">
          {{ $t('message["194"]') }}
        </div>
        <div class="select-box">
          {{ $t('message["260"]') }}
          <a-tooltip
            placement="top"
            overlay-class-name="prompt-tooltip"
          >
            <template slot="title">
              1. {{ $t('message["257"]') }}
              2. {{ $t('message["63"]') }}-
            </template>
            <i
              class="iconfont iconicon-test34 fs-gray explain-btn"
            />
          </a-tooltip>
        </div>
      </li>

      <li
        v-for="(row, i) in allData"
        :key="row.excelKey"
        class="item clearfix"
      >
        <div class="excel-title">
          {{ row.excelTitle }}
        </div>
        <div class="select-box">
          <a-select
            :value="row.selectValue"
            allow-clear
            :show-search="true"
            :filter-option="filterOption"
            dropdown-class-name="import-type-select"
            :placeholder="selectPlaceholder"
            @dropdownVisibleChange="dropdownVisibleChange($event, i, row)"
            @change="handleTypeChange($event, i, row)"
          >
            <a-select-opt-group
              v-for="modules in row.selectOptions"
              :key="modules.fieldkey"
              :class="{hide: setShowSelectGroup(modules) }"
            >
              <span
                v-if="modules.fieldname"
                slot="label"
              >{{ modules.fieldname }}</span>
              <a-select-option
                v-for="item in modules.child"
                :key="item.fieldkey"
                :value="item.fieldkey"
                :disabled="item.chooseed"
                :class="{hide: item.chooseed}"
              >
                {{ item.fieldname }}<span v-if="item.fieldtype_desc">[{{ item.fieldtype_desc }}]</span>
              </a-select-option>
            </a-select-opt-group>
          </a-select>
        </div>
        <div class="right">
          <i
            v-if="row.success"
            class="iconfont iconicon-test33 fs-green success-icon"
          />
          <!-- <span v-if="row.warn">
            <i class="iconfont iconicon-test68 fs-orange error-icon" />
            <span
              v-if="validResultData.result"
              class="fs-orange error-msg"
            >表中有{{ validResultData.result.length }}条数据{{ row.excelTitle }}格式有误</span>
            <a
              href="###"
              class="look-btn fs-blue"
              @click="handleLook"
            >查看</a>
          </span>
 -->
          <a
            v-if="showSetBtn(row.currField)"
            class="set-btn fs-blue"
            @click="setAggregation(row.excelKey, row)"
          >
            <span
              v-if="!row.success"
            >{{ row.currField.fieldtype === 'select_user' ? setPersonT[0] : setPersonT[1] }}</span>
            <span v-else>{{ $t('message["1472"]') }}</span>
          </a>
        </div>
      </li>
    </ul>
    <div
      v-else
      class="loading-box wrong-box"
    >
      <div v-if="excelHeaderError">
        <img
          src="@/assets/images/wrong.png"
          class="wrong-img"
        >
        <p class="fs-gray">
          {{ $t('message["522"]') }}
        </p>
        <a-button
          class="new-btn"
          type="primary"
          @click="handlePrev"
        >
          {{ $t('message["1619"]') }}
        </a-button>
      </div>
      <div v-else>
        <a-spin />
        <p class="fs-gray">
          {{ $t('message["1270"]') }}
        </p>
      </div>
    </div>
    <div
      v-if="!loading && excelHeader && Object.keys(excelHeader).length"
      class="footer"
    >
      <a-button
        :disabled="allData.filter(item => !item.success).length !== 0"
        type="primary"
        @click="handleImport"
      >
        {{ $t('message["560"]') }}
      </a-button>
      <a-button
        @click="handlePrev"
      >
        {{ $t('message["1000"]') }}
      </a-button>
    </div>
    <!-- <warn-modal
      :visible.sync="showWarnModal"
      :data="validResultData"
      @confirm="warnConfirm"
    /> -->
    <aggregation-modal
      :visible.sync="showAggregationModal"
      :params="aggregationParams"
      :options="aggregationOptions"
      :row="currentRow"
      @confirm="aggregationConfirm"
    />
    <leave-tip-dialog
      ref="leaveTip"
      @leavelHandler="leavelHandler"
    >
      <div slot="tip-slot">
        {{ $t('message["1512"]') }}，<br>
        {{ $t('message["920"]') }}？
      </div>
    </leave-tip-dialog>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations } from 'vuex'
// import WarnModal from './WarnModal'
import AggregationModal from './AggregationModal'
import LeaveTipDialog from '@/components/pc/LeaveTipDialog'

export default {
  components: {
    // WarnModal,
    AggregationModal,
    LeaveTipDialog
  },

  data () {
    return {
      // validResultData: {},
      aggregationParams: {},
      aggregationOptions: [],
      // showWarnModal: false,
      showAggregationModal: false,
      currentRow: {},
      fieldsConfig: [],
      timer: null,
      excelHeaderError: false
    }
  },

  computed: {
    ...mapState('config/batchImport', ['loading', 'excelHeader', 'importFields', 'isBackObj']),
    importId () {
      return this.$route.query.id
    },
    newSelectFields () {
      const { importFields = {} } = this
      let ignore = {
        fieldkey: 'ignore',
        fieldname: '',
        child: [{
          fieldkey: 'ignore',
          fieldtype: 'ignore',
          fieldname: `-${this.$t('message["437"]')}-`
        }]
      }
      return {
        ignore,
        ...importFields
      }
    },
    allData () {
      let arr = []

      for (let k in this.excelHeader) {
        let title = this.excelHeader[k]
        let obj = {
          excelKey: k,
          excelTitle: title,
          selectValue: undefined,
          selectOptions: this.newSelectFields,
          success: false
          // warn: false
        }

        for (let i in obj.selectOptions) {
          let modules = obj.selectOptions[i]
          let modulesChild = modules.child || []

          for (let j in modulesChild) {
            let field = modulesChild[j]

            if (title === field.fieldname) {
              obj.currField = field
              if (field.fieldkey === 'ignore') {
                obj.selectOptions[i].child[j].chooseed = false
              } else {
                obj.selectOptions[i].child[j].chooseed = true
              }
              // field.fieldvalue = field.fieldkey || ''
              obj.selectValue = field.fieldvalue || field.fieldkey || undefined

              if (field.fieldtype === 'text' || field.fieldtype === 'editor' || field.fieldtype === 'area' || field.fieldtype === 'file' || field.fieldtype === 'tag' || field.fieldtype === 'number' || field.fieldtype === 'email' || field.fieldtype === 'phone' || field.fieldtype === 'ip' || field.fieldtype === 'datetime') {
                obj.success = true
              /* } else if (field.fieldtype === 'datetime') {
                this.checkDatatime(obj, obj.selectValue) */
              } else {
                // 需选择对应关系
              }
            }
          }
        }
        arr.push(obj)
      }

      return arr
    },
    selectPlaceholder () {
      return this.$t('message["855"]')
    },
    setPersonT () {
      return this.$t('message["1018"]').split('|')
    }
  },

  beforeRouteLeave (to, from, next) {
    if (this.isBackObj.count > 0 && !this.isBackObj.hasSumbit) {
      if (this.isBackObj.status) {
        this.removeClick()
        next()
        return
      }
      this.$refs.leaveTip.changeLimitDialog(true)
      this.setIsBackObj({
        leave: to
      })
      next(false)
    } else {
      this.removeClick()
      next()
    }
  },

  created () {
    this.init()
    this.fetchImportFields({
      id: this.importId
    })
    this.setIsBackObj({
      hasSumbit: false,
      count: 0,
      status: false
    })
  },

  destroyed () {
    clearTimeout(this.timer)
  },

  methods: {
    ...mapActions('config/batchImport', ['fetchImportTableHeader', 'fetchImportFields', 'importValidFormat', 'setFields', 'addClick', 'removeClick']),
    ...mapMutations('config/batchImport', ['setIsBackObj']),
    async init () {
      let vm = this

      if (vm.excelHeader && Object.keys(vm.excelHeader).length) {
        clearTimeout(vm.timer)
      }

      let chain = await this.fetchImportTableHeader({
        id: this.importId
      })
      chain
        .onSuccess(res => {
          if (!res.tableheader) {
            if (res.errorInfo) {
              vm.excelHeaderError = true
            } else {
              vm.excelHeaderError = false
              vm.timer = setTimeout(() => {
                vm.init()
              }, 5000)
              if (vm.excelHeader && Object.keys(vm.excelHeader).length) {
                clearTimeout(vm.timer)
              }
            }
          }
        })
    },

    filterOption (input, option = {}) {
      let { componentOptions = {} } = option
      let { children = [] } = componentOptions
      let { text = '' } = children[0]
      return text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    showSetBtn (item = {}) {
      let res = false
      let fieldtype = item.fieldtype || ''

      if (fieldtype === 'radio' || fieldtype === 'select' || fieldtype === 'checkbox' || fieldtype === 'select_tree' || fieldtype === 'radioinfo_followup' || fieldtype === 'radioinfo_payfor' || fieldtype === 'radioinfo_level' || fieldtype === 'radioinfo_type' || fieldtype === 'radioinfo_sign' || fieldtype === 'select_user' || fieldtype === 'select_reception') {
        res = true
      } else {
        res = false
      }
      return res
    },

    setShowSelectGroup (modules = {}) {
      let len = 0
      let res = false
      if (modules.child && this.$toType(modules.child) === 'array') {
        len = modules.child && modules.child.filter(item => item.chooseed).length
        res = len === modules.child.length
      }

      return res
    },

    dropdownVisibleChange (value, index, row) {
      if (value) {
        for (let j in row.selectOptions) {
          let module = row.selectOptions[j]
          for (let k in module.child) {
            if (module.child[k].fieldkey === row.selectValue) {
              row.selectOptions[j].child[k].chooseed = false
              this.allData.splice(index, 1, row)
            }
          }
        }
      }
    },

    async handleTypeChange (value, index, row) {
      if (!value) {
        value = undefined
        row.selectValue = value
        row.success = false
        row.aggregationList = []
        row.currField = {}
        for (let k in row.selectOptions) {
          let module = row.selectOptions[k]
          for (let i in module.child) {
            let item = module.child[i]
            if (row.currField && item.fieldkey === row.currField.fieldkey) {
              row.selectOptions[k].child[i].chooseed = false
            }
          }
        }
        this.allData.splice(index, 1, row)
        this.$forceUpdate()
        return
      }

      row.selectValue = value

      for (let k in row.selectOptions) {
        for (let j in row.selectOptions[k].child) {
          let field = row.selectOptions[k].child[j]
          if (field.fieldkey === value) {
            row.currField = field

            for (let i in this.allData) {
              let oneRow = this.allData[i]
              oneRow.selectOptions[k].child[j].chooseed = true

              if (field.fieldkey === 'ignore') {
                oneRow.selectOptions[k].child[j].chooseed = false
              }

              this.allData.splice(i, 1, oneRow)
              this.$forceUpdate()
            }

            // row.selectOptions[k].child[j].chooseed = false
          }
        }
      }

      if (row.currField) {
      // 重新选择选项类型
        let { fieldtype } = row.currField
        if (fieldtype === 'radio' || fieldtype === 'select' || fieldtype === 'checkbox' || fieldtype === 'select_tree' || fieldtype === 'radioinfo_followup' || fieldtype === 'radioinfo_payfor' || fieldtype === 'radioinfo_level' || fieldtype === 'radioinfo_type' || fieldtype === 'radioinfo_sign' || fieldtype === 'select_user' || fieldtype === 'select_reception') {
          row.success = false
          // row.warn = false
        /* } else if (fieldtype === 'datetime') {
          // 校验-时间类型
          let res = await this.validFormat({
            id: this.importId,
            column: row.excelKey
          })
          this.validResultData.result = res
          this.validResultData.row = row
          this.validResultData.selectValue = value

          if (res.length) {
            // row.warn = true
            row.success = false
          } else {
            row.success = true
          } */
        } else {
          // row.warn = false
          row.success = true
        }
      }

      this.allData.splice(index, 1, row)
      this.$forceUpdate()

      let { count } = this.isBackObj
      count++
      this.setIsBackObj({
        count
      })
      this.removeClick()
      this.addClick()
    },
    async checkDatatime (row, value) {
      // 校验-时间类型
      let res = await this.validFormat({
        id: this.importId,
        column: row.excelKey
      })
      /* this.validResultData.result = res
      this.validResultData.row = row
      this.validResultData.selectValue = value */

      if (res.length) {
        // row.warn = true
        row.success = false
      } else {
        row.success = true
      }
    },
    validFormat (params) {
      return new Promise(async (resolve, reject) => {
        let chain = await this.importValidFormat(params)

        chain.onSuccess(payload => {
          resolve(payload || {})
        })
      })
    },
    handleLook () {
      this.showWarnModal = true
    },
    setAggregation (k, row) {
      this.showAggregationModal = true

      this.currentRow = row

      this.aggregationParams = {
        id: this.importId,
        column: k
      }

      this.aggregationOptions = row.currField.options

      let { count } = this.isBackObj
      count++
      this.setIsBackObj({
        count
      })
      this.removeClick()
      this.addClick()
    },
    aggregationConfirm (data, currRow) {
      let filters = data.filter(item => !item.status)
      if (!filters.length) {
        for (let i in this.allData) {
          let row = this.allData[i]
          if (row.excelKey === currRow.excelKey) {
            row.success = true
            row.aggregationList = data.map(item => {
              let { currField = {} } = currRow
              let { fieldtype } = currField
              let selectVal
              if (fieldtype === 'select_user' && item.selectVal && Array.isArray(item.selectVal)) {
                if (item.selectVal.length === 1 && item.selectVal[0] === 'ignore-ignore') {
                  selectVal = 'ignore'
                } else {
                  selectVal = {}
                  item.selectVal.forEach(one => {
                    let k = one.split('-')[1]
                    let val = one.split('-')[0]
                    selectVal[k] = val
                  })
                }
              } else {
                selectVal = item.selectVal
              }

              return {
                isignore: selectVal === 'ignore' ? 1 : 0,
                chartvalue: item.name,
                fieldvalue: selectVal === 'ignore' ? '' : selectVal
              }
            })
            this.allData.splice(i, 1, row)
          }
        }
      }
    },
    /* warnConfirm (currRow) {
      for (let i in this.allData) {
        let row = this.allData[i]
        if (row.excelKey === currRow.excelKey) {
          this.allData.splice(i, 1, currRow)
        }
      }
    }, */

    handlePrev () {
      this.$router.push({
        name: 'configImportFirst'
      })
    },
    async handleImport () {
      let config = []

      for (let row of this.allData) {
        let obj = {}
        obj.options = row.aggregationList
        obj.charttitle = row.excelTitle
        obj.chartkey = row.excelKey
        obj.isignore = row.selectValue === 'ignore' ? 1 : 0
        if (row.selectValue !== 'ignore') {
          obj.fieldkey = row.selectValue
        }

        config.push(obj)
      }

      this.fieldsConfig = config

      this.setFieldsData(config)
    },

    async setFieldsData (config) {
      let params = {
        id: this.importId,
        config
      }
      let chain = await this.setFields(params)
      chain.onSuccess(payload => {
        this.setIsBackObj({
          hasSumbit: true,
          count: 0
        })
        this.removeClick()
        this.$router.push({
          name: 'configImportFinish'
        })
      })
    },
    leavelHandler (b) {
      const { leave } = this.isBackObj
      if (b) {
        this.isBackObj.status = true
        this.isBackObj.count = 0
        this.$router.push({ name: leave.name, query: leave.query, params: leave.params })
      } else {
        this.isBackObj.status = false
      }
      this.setIsBackObj({
        status: this.isBackObj.status,
        count: this.isBackObj.count
      })
      this.$refs.leaveTip.changeLimitDialog(false)
    }
  }
}
</script>

<style lang="scss" scoped>
.second-module {
  width: 1038px;
  .header {
    height: 48px;
    line-height: 48px;
    background: rgba(245, 246, 247, 1);
    border-radius: 4px 0px 0px 4px;
    > div {
      padding: 0 16px;
      font-weight: bold;
    }
  }
  .item {
    overflow: hidden;
    width: 100%;
    line-height: 48px;
    border-bottom: solid 1px #e8e8e8;
  }
  .excel-title, .select-box, .right {
    float: left;
    padding: 0 16px;
  }

  .excel-title {
    width: 280px
  }
  .select-box {
    width: 440px;
    .ant-select {
      width: 408px;
    }
  }
  .right {
    margin-left: 12px;
    padding: 0;
    .success-icon, .error-icon {
      margin-right: 5px;
    }
    .error-msg {
      margin-right: 8px;
    }
  }
}
.loading-box {
  margin: 100px 0;
  text-align: center;
  &.wrong-box {
    margin: 40px 0;
  }
  p {
    margin-top: 10px;
  }
  .wrong-img {
    display: block;
    width: 183px;
    margin: 0 auto 22px;
  }
  .new-btn {
    margin-top: 16px;
  }
}
.footer {
  padding: 40px 16px;
  .ant-btn.ant-btn-primary[disabled] {
    background:linear-gradient(360deg,rgba(80,119,170,1) 0%,rgba(96,143,204,1) 100%);
    box-shadow:0px 1px 1px 0px rgba(255,255,255,0.5);
    border-radius:4px;
    opacity:0.5;
    color: #fff;
    border:1px solid rgba(80,119,170,1);
  }
}
</style>

<style lang="scss">
.prompt-tooltip {
  min-width: 200px;
  max-width: 400px;
  .ant-tooltip-inner {
    color: $gray3;
    min-width: 200px;
    max-width: 400px;
  }
  .ant-tooltip-content:after {
    content: "";
    position: absolute;
    width: 0;
    height: 0;
    left: 50%;
    margin-left: -7px;
    border-width: 7px 7px 0px 7px;
    border-color: transparent;
    border-top-color: #ebebeb;
    border-style: solid;
  }
  &.ant-tooltip-placement-top {
    .ant-tooltip-arrow {
      bottom: -4px !important;
      z-index: 2;
      border-top-color: #fff !important;
    }
  }
}
/* 万能表单 下拉内的忽略选项隐藏 */
.ant-select-dropdown.import-type-select {
  .ant-select-dropdown-menu-item-group-title[title='ignore'] {
    display: none;
  }
}
</style>
